import React, { useState } from "react";
import { getFullRssUrl, podcastId } from "../../config";
import { Button, Input } from "../../designSystem";

/** RSS 订阅链接 + 一键复制。有 podcast_session 时给出私人链接。 */
const RssTextField = ({ podcastSession, style }) => {
  const [copied, setCopied] = useState(false);
  const rss =
    podcastSession === null || podcastSession === ""
      ? getFullRssUrl(`/rss/${podcastId}/`)
      : getFullRssUrl(`/rss/${podcastId}/${podcastSession}`);

  const handleCopy = () => {
    navigator.clipboard.writeText(rss).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="lt-rss" style={style}>
      <Input
        icon="rss_feed"
        value={rss}
        readOnly
        onClick={(e) => e.target.select && e.target.select()}
        aria-label="RSS 订阅链接"
      />
      <Button
        variant={copied ? "secondary" : "primary"}
        icon={copied ? "check" : "content_copy"}
        onClick={handleCopy}
      >
        {copied ? "已复制" : "复制"}
      </Button>
    </div>
  );
};

export default RssTextField;
